
// @flow
import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import navLinkBottoms from '../../constans/navLinkBottoms';
import { useUser } from '../../customHooks/Account';
import NavVideoOffCommingSoon from '../../../assets/images/nav_video_off_comming_soon.png'

type Props = {
    activeNav: any
};

const BottomNavigation = ({ activeNav }: Props) => {

    // const { userInfo } = useSelector((state) => state.authReducers);
    
    const { user } = useUser();
    const navigate = useNavigate();

    const goToNav = (nav) => {
        navigate(nav);
    }

    const handleCamera = () => {
        console.log('camera');
        window.nativeOpenCamera();
    }

    useEffect(() => {

    }, [user.album_badge_count])

    const renderNavLinkBottoms = () => 
        navLinkBottoms && navLinkBottoms.map((nav, index) => {
            let navIconOn = nav.icon.on;
            let navIconOff = nav.icon.off;
            if(nav.name !== 'CAMERA'){
                let badgeCls = user?.album_badge_count && nav.name == 'ALBUM' ? 'album-badge-count' : '';
                if (nav.name === 'VIDEO' && process.env.REACT_APP_DISABLED_VIDEO_MESSAGE === 'true') {
                    return (<li key={index}>
                        <a>
                            <img className={nav.className.on} src={NavVideoOffCommingSoon}/>
                            <img className={nav.className.off} src={NavVideoOffCommingSoon}/>
                        </a>
                    </li>)
                }else{
                    return (<li key={index}>
                        <a onClick={() => goToNav(nav.toUrl)} className={`${badgeCls} ${activeNav == nav.name ? 'active' : ''} `}>
                            {/* <img className={nav.className.on} src={nav.icon.on}/>
                            <img className={nav.className.off} src={nav.icon.off}/> */}
                            <span className={nav.className.on}>
                                {navIconOn}
                            </span>
                            <span className={nav.className.off}>
                                {navIconOff}
                            </span>
                        </a>
                        {
                            user?.album_badge_count > 0 && nav.name == 'ALBUM' ?  
                            user?.album_badge_count > 99 ? 
                            <div className='badge-number-99'>
                                <div className='badge-number-parent'>
                                    <span>99+</span>
                                </div>
                            </div> : 
                            <div className={user?.album_badge_count > 9 ? 'badge-number-10' : 'badge-number-9'}>
                                <div className='badge-number-parent'>
                                    <span>{user?.album_badge_count}</span>
                                </div>
                            </div> : ''
                        }
                    </li>)
                }
                
            }else{
                return (<li key={index}>
                    <a onClick={handleCamera}>
                        {/* <img className={nav.className.on} src={nav.icon.on}/>
                        <img className={nav.className.off} src={nav.icon.off}/> */}

                        <span className={nav.className.on}>
                            {navIconOn}
                        </span>
                        <span className={nav.className.off}>
                            {navIconOff}
                        </span>
                    </a>
                </li>)
            }

    });

    return (
        <nav className="bottom-nav">
            <ul>
                {renderNavLinkBottoms()}
            </ul>
        </nav>
    );
};

BottomNavigation.defaultProps = {
    activeNav: false
};

export default memo(BottomNavigation);
